// Local Storage Keys
export const LOCAL_STORAGE_PROJECT_UUID_KEY = '@ls-client/current-project-uuid';
export const LOCAL_STORAGE_CURRENT_CUSTOMER_KEY = '@ls-client/current-customer';
export const LOCAL_STORAGE_CHECK_ONBOARDING_KEY = '@ls-client/check-onboarding';
